// ©2024 Austin App House. All rights reserved.
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Field, Form, reduxForm } from 'redux-form';
import { withRouter } from 'react-router-dom';
import { toggleModal } from '../../../storage/actions/modalsActions';
import Notification from '../../notification';
import defaultInitialValues from '../../../utils/reduxForm/InitialValues/addFundingSourceToDwollaBySuperAdmin';
import InputField from './customFields/InputField';
import ReactSelectField from './customFields/ReactSelectField';
import { accountStatusOptions } from '../../../utils/constans';

const fieldProps = {
  paddingBottomClassName: '',
  inputClassName: 'dashboard-input',
};

let AddFundingSourceToDwollaBySuperAdminReduxForm = ({
  handleSubmit,
  error,
}) => {
  useEffect(() => {
    if (error) Notification('error', { message: error });
  }, [error]);

  const preventSubmitOnEnter = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  };

  return (
    <Form
      onSubmit={handleSubmit}
      onKeyPress={preventSubmitOnEnter}
    >
      <div className="field_col">
        <label className="field_name" htmlFor="bank-name">
          Bank Name
        </label>
        <Field
          id="bank-name"
          name="name"
          component={InputField}
          type="text"
          placeholder="Bank Name"
          required
          {...fieldProps}
        />
      </div>

      <div className="field_col">
        <label className="field_name" htmlFor="account-holder-name">
          Account Holder Name
        </label>
        <Field
          id="account-holder-name"
          name="accountHolderName"
          component={InputField}
          type="text"
          placeholder="Account Holder Name"
          required
          {...fieldProps}
        />
      </div>

      <div className="field_col">
        <label className="field_name" htmlFor="account-status">
          Checking or Savings Acct
        </label>
        <Field
          id="account-status"
          name="accountStatus"
          component={ReactSelectField}
          label=""
          placeholder="Select account type"
          options={accountStatusOptions}
          customSelectStyleType="dashboard"
          isSearchable={false}
          isClearable={false}
          required
        />
      </div>

      <div className="field_col">
        <label className="field_name" htmlFor="routing-number">
          Routing
        </label>
        <Field
          id="routing-number"
          name="routing"
          component={InputField}
          type="text"
          placeholder="Routing Number"
          required
          {...fieldProps}
        />
      </div>

      <div className="field_col">
        <label className="field_name" htmlFor="account-number">
          Account
        </label>
        <Field
          id="account-number"
          name="account"
          component={InputField}
          type="text"
          placeholder="Account Number"
          required
          {...fieldProps}
        />
      </div>
    </Form>
  );
};

AddFundingSourceToDwollaBySuperAdminReduxForm = reduxForm({
  form: 'addFundingSourceToDwollaBySuperAdminReduxForm',
})(AddFundingSourceToDwollaBySuperAdminReduxForm);

const mapDispatchToProps = {
  toggleModal,
};

const mapStateToProps = () => ({
  initialValues: defaultInitialValues,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(AddFundingSourceToDwollaBySuperAdminReduxForm));
